module.exports = __webpack_public_path__ + "img/88.7.Chla.67ab5417.png";